import request from "../../Request";
import {rThen} from "../../requestThen";

export const getGroupStats = async (id) => {
  return request.get(`/api/olymp/get_group_stats/${id}`, true).then(r => {
     return rThen(r);
   })
}